import React, { useState } from "react";
import { cacheNames } from "workbox-core";
import { Spinner, Tooltip } from "components";
import { useTranslation } from "hooks";
import { PRECACHE_FILES_COUNT } from "./duck/constants";
import styles from "./Installing.module.css";

const Installing: React.FC = () => {
  const { t } = useTranslation();
  const [keysLength, setKeysLength] = useState(0);
  const [percentage, setPercentage] = useState(0);

  React.useEffect(() => {
    const checkStatusInterval = setInterval(() => {
      caches
        .open(`${cacheNames.precache}-${window.location.origin}/`)
        .then((cache: Cache) => {
          cache.keys().then((keys) => {
            setKeysLength(keys.length);
            if (keys.length >= PRECACHE_FILES_COUNT) {
              clearInterval(checkStatusInterval);
            }
          });
        });
    }, 500);

    return () => {
      clearInterval(checkStatusInterval);
    };
  }, []);

  React.useEffect(() => {
    setPercentage(Math.ceil((100 * keysLength) / PRECACHE_FILES_COUNT));
  }, [keysLength]);

  return (
    <Tooltip
      trigger={["hover", "click"]}
      position="bottom"
      content={
        percentage < 100 ? t("offline.preparing") : t("offline.updating")
      }
    >
      <button type="button" className={styles.wrapper}>
        <Spinner size="small" className={styles.spinner} />
        <span className={styles.ready}>
          {percentage < 100 ? `${percentage}%` : ""}
        </span>
      </button>
    </Tooltip>
  );
};

export default Installing;
